module.exports = __webpack_public_path__ + "static/media/bottomTopLeftDark.9cce0a3b.svg";